import "./style.css";
import Fundo from '../../assets/Fundo.png';
import { useState } from "react";
import React from 'react';
import api from '../../services/api.js';
import { useNavigate } from "react-router-dom";
import { useAppContext } from '../../context/AppContext.js';
import Modal from "react-modal";

function Login() {
    const navigate = useNavigate();
    const [usuario, setusuario] = useState('');
    const [senha, setsenha] = useState('');
    const [sucesso, setsucesso] = useState('');
    const [loading, setloading] = useState(false);

    const [showModal, setShowModal] = useState(false);
    const [novaSenha, setNovaSenha] = useState('');
    const [confirmarSenha, setConfirmarSenha] = useState('');
    const [errorSenha, setErrorSenha] = useState('');

    const { codcolaborador, setCodColaborador, setIsGestor, selectedCompany, setAccessKey, setNomeDoColaborador, setFotoPerfil } = useAppContext();

    function ProcessaLogin(e) {
        e.preventDefault();
        setsucesso('');
        setloading(true);
        api.post('v1/login', {
            codempresa: selectedCompany,
            usuario,
            senha
        }).then(response => {        
            setAccessKey(response.data.token); 
            setCodColaborador(response.data.codcolaborador);
            setNomeDoColaborador(response.data.nome);
            setIsGestor(response.data.supervisor === 'S');
            setFotoPerfil(response.data.fotoperfil);

            if (response.data.senhaatualizada === "N") {
                // abrir modal para atualizar senha
                setShowModal(true);
                setloading(false);
            } else {
                setsucesso('S');
                navigate('/principal');
            }
        }).catch(() => {
            setsucesso('N');
            setloading(false);
        })
    }

    function atualizarSenha() {
        if (!novaSenha || !confirmarSenha) {
            setErrorSenha("Preencha todos os campos");
            return;
        }
        if (novaSenha !== confirmarSenha) {
            setErrorSenha("As senhas não conferem");
            return;
        }

        setErrorSenha("");
        setloading(true);

        api.post("v1/atualizarsenha", {
            codcolaborador,
            senha: novaSenha
        }).then(() => {
            setShowModal(false);
            setsucesso('S');
            navigate('/principal');
        }).catch(() => {
            setErrorSenha("Erro ao atualizar senha, tente novamente.");
            setloading(false);
        });
    }

    return (
        <div className="container">
            <div className="logina">
                <img className="background-login" src={Fundo} alt="Fundo" />
                <form className="form-login">
                    <h3 className="mb-4">Autenticação</h3>

                    <div className="form-floating">
                        <input onChange={(e) => setusuario(e.target.value)} type="text" className="form-control" id="usuario" placeholder="Usuário" />
                        <label htmlFor="usuario">Usuário</label>
                    </div>

                    <div className="form-floating">
                        <input onChange={(e) => setsenha(e.target.value)} type="password" className="form-control" id="senha" placeholder="Senha" />
                        <label htmlFor="senha">Senha</label>
                    </div>

                    <button onClick={ProcessaLogin} className="w-100 btn btn-lg btn-success" disabled={loading}>
                        {loading ? <div>
                            <span className="spinner-border spinner-border-sm text-light" role="status"></span>
                            <span className="ms-2">Autenticando...</span>
                        </div> : <span className="ms-2">Acessar</span>}
                    </button>
                    {sucesso === 'N' ? <div className="alert alert-danger mt-2" role="alert">Usuário ou senha inválidos</div> : null}
                </form>
            </div>

            {/* Modal de atualização de senha */}
            <Modal
                isOpen={showModal}
                onRequestClose={() => setShowModal(false)}
                ariaHideApp={false}
                className="modal-dialog"
                overlayClassName="modal-backdrop"
            >
                <div className="modal-content p-4">
                    <h5>Atualizar Senha</h5>
                    <div className="form-floating mb-3">
                        <input type="password" className="form-control" id="novaSenha" placeholder="Nova Senha" value={novaSenha} onChange={(e) => setNovaSenha(e.target.value)} />
                        <label htmlFor="novaSenha">Nova Senha</label>
                    </div>
                    <div className="form-floating mb-3">
                        <input type="password" className="form-control" id="confirmarSenha" placeholder="Confirmar Senha" value={confirmarSenha} onChange={(e) => setConfirmarSenha(e.target.value)} />
                        <label htmlFor="confirmarSenha">Confirmar Senha</label>
                    </div>
                    {errorSenha && <div className="alert alert-danger">{errorSenha}</div>}
                    <button className="btn btn-success w-100" onClick={atualizarSenha} disabled={loading}>
                        {loading ? "Atualizando..." : "Salvar Nova Senha"}
                    </button>
                </div>
            </Modal>
        </div>
    )
}

export default Login;
